import cssUtil from 'gw-portals-util-js/CssUtil';
import templateStr from 'text!./pa-vin-lookup.html';
import styles from './PAVinLookup-hashed.scss';
import ctrl from './PAVinLookupCtrl';

class PAVinLookup {

    constructor() {
        this.restrict = 'E';
        this.template = cssUtil.hashTemplate(templateStr, styles);
        this.scope = {
            vehicle: '=',
            vinLoaded: '=',
            tooltip: '=?'
        };
        this.controller = ctrl;
    }
}
export default PAVinLookup;